import { Subject } from 'rxjs';

const subject = new Subject();

export const attachmentVersionService = {
  emitReload: val => subject.next(val),
  reload: () => subject.asObservable()
};